// extracted by mini-css-extract-plugin
export default {"contents":"FE-z","sectionHeading":"GE-z"};